import { Serializable } from './Serializable';
import { KeyDriversDTO } from './KeyDriversDTO';
import { Utils } from '../utils/utils';

export class ActionDTO extends Serializable {
    id: string;
    title: string;
    description: string;
    from: string;
    to: string;
    frequency: number;
    frequencyName: string;
    keyDriverID: string;
    keyDriver: KeyDriversDTO;
    resourceURL: string;
    thumbnail: string;
    resourceType: number;
    resourceTypeName: string;
    resourceCategoryID: string;
    resourceCategoryName: string;
    resourceLevel: number;
    resourceLevelName: string;
    clientId: string;
    canAdministrate: boolean;

    constructor() {
        super();
    }

    get keyDriverTitle() {
        let title = '--';
        if (this.keyDriver) {
            title = this.keyDriver.visibleName;
        }
        return title;
    }

    get dateFromFormat() {
        let date = new Date(this.from);
        return Utils.dateToString(date);
    }

    get dateToFormat() {
        let date = new Date(this.to);
        return Utils.dateToString(date);
    }

    isGlobal(): boolean {
        return this.clientId == null;
    }
    
}
